import {Component, OnInit} from '@angular/core';
import {LayoutService} from '../../layout.service';
import { NotificationService } from 'app/core/services/notification.service';
import { AuthenticationService } from 'app/+auth/+login/authentication.service';
import { Encoder } from 'app/shared/utils/encoder';

declare var $: any;

@Component({
  selector: 'sa-change-password',
  templateUrl: './change-password.component.html'
})
export class ChangePasswordComponent implements OnInit {

  viewModalChangePassword : boolean = false ;
  modal: any ;
  responseFinal  :any ;
  messageResponse : string ="";
  viewMessageResponse : boolean = false ;
  newPassword : string;
  encoder :  Encoder; 
  
  datai18n : any;
  title: string;
  titleModal: string;
  oldPassword: string;
  nPassword: string;
  repeatNewPassword: string;
  ButtonSend: string;
  ButtonCancel: string;
  Message: string;
  ButtonOk: string; 
  constructor(
    private layoutService: LayoutService,
    private notificationService :  NotificationService,
    private authenticationService: AuthenticationService,
  ) {

  }

  ngOnInit() {
    this.modal ={}
    this.encoder = new Encoder();

    this.datai18n = JSON.parse(localStorage.getItem('datai18n'));
    this.title = this.datai18n['Header.changePassword'];
    this.titleModal = this.datai18n['ChangePassword.titleModal'];
    this.oldPassword = this.datai18n['ChangePassword.oldPassword'];
    this.nPassword = this.datai18n['ChangePassword.nPassword'];
    this.repeatNewPassword = this.datai18n['ChangePassword.repeatNewPassword'];
    this.ButtonSend = this.datai18n['ChangePassword.ButtonSend'];
    this.ButtonCancel = this.datai18n['ChangePassword.ButtonCancel'];
    this.Message = this.datai18n['ChangePassword.Message'];
    this.ButtonOk = this.datai18n['ChangePassword.ButtonOk'];
     
  }

  onToggle() {
    this.layoutService.onCollapseMenu()
  }

  onChangePassword(){
    //console.log("opening modal change Password .");
    this.viewModalChangePassword = true ;

    }
   
    sendChanngePassword(){
        if(this.validateForm(this.modal)){
          if(this.validateEqualPassword(this.modal)){
            const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
            let user = currentUser.userSystem;
            //console.log(user);
            let oldPassword = this.encoder.encriptar(this.modal.oldPassword);
            let newPassword = this.encoder.encriptar(this.modal.newPassword);
            this.authenticationService.changePassword(user.id , oldPassword,newPassword)
            .subscribe((data) => { 
                  this.messageResponse = "";
                  let response = data;
                  //console.log(data);
                  this.responseFinal= response;
                  this.viewMessageResponse=true;
                  if(response ==0){ 
                      this.messageResponse = this.datai18n['ChangePassword.response.incorrecPassword'];
                  }
                  else if(response ==1 ){ 
                      this.messageResponse = this.datai18n['ChangePassword.response.successful'];
                      sessionStorage.setItem('pass', newPassword);
                  }
                  else{ 
                    this.messageResponse = this.datai18n['ChangePassword.response.wrongService'];
                  }   
                },
                error => {
                    // debugger;
                    //console.log("No se pudo realizar la petición.. ");
                    this.viewMessageResponse=true;
                    this.messageResponse = this.datai18n['ChangePassword.response.wrongService'];
                    this.responseFinal= 3;
                    //console.log("error : ",error);
                    //this.router.navigate(['']);
                }); 
          }
        }
    }
    cancel(){
      this.viewModalChangePassword = false ;
      this.modal ={};
    }

    validateForm(modal){
      if(modal.oldPassword == null || modal.newPassword == null || modal.newPassword2 == null ||
        modal.oldPassword == "" || modal.newPassword == "" || modal.newPassword2 == ""){
          let text = this.datai18n['ChangePassword.invalid.requiredField'];
          this.notificationService.serverWarningMessage(text);
            return false;
      }else if (!this.validarPassword(modal.newPassword) &&  !this.validarPassword(modal.newPassword2)){
        this.notificationService.serverWarningMessage("La contraseña no cumple con los requisitos.");
        return false;
      }
      else
        return true;
    }

    validateEqualPassword(modal){
        if(modal.newPassword === modal.newPassword2){
          return true ;
        }
        else{
          let text = this.datai18n['ChangePassword.invalid.equalsPasswords'];
          this.notificationService.serverWarningMessage(text);
            return false;
        }
    }

    ok(){
      this.viewMessageResponse = false;
      if(this.responseFinal==1){
        this.viewModalChangePassword = false ; 
        this.modal={};
      } 
    }

    validarPassword(password: string): boolean {
      // Expresión regular que verifica los tres requisitos
      const regex = /^(?=.*[0-9])(?=.*[\W_]).{8,}$/;
    
      // Si la contraseña cumple con los requisitos, devuelve true
      return regex.test(password);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/change-password/change-password.component.ts